import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateDeviceAction } from 'js/hooks/device/store/actions';
import { getDevice, isScreenOrientationSupported } from 'js/hooks/device/helpers';

export const useOnDeviceChange = () => {
    const dispatch = useDispatch();

    const updateDeviceOrientation = useCallback(() => {
        dispatch(updateDeviceAction(getDevice()));
    }, [
        dispatch
    ]);

    /**
     * Update device on orientation change
     */
    useEffect(() => {
        if (isScreenOrientationSupported) {
            screen.orientation.addEventListener('change', updateDeviceOrientation);

            return () => {
                screen.orientation.removeEventListener('change', updateDeviceOrientation);
            };
        }

        window.addEventListener('orientationchange', updateDeviceOrientation);

        return () => {
            window.removeEventListener('orientationchange', updateDeviceOrientation);
        };
    }, [updateDeviceOrientation]);
};
